exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.nil-sa-elements-toggle-style__text{display:inline-block;width:100%;font-size:16px;max-width:550px;margin-bottom:20px;padding-right:30px}div.nil-sa-elements-toggle-style__body{cursor:pointer;display:inline-block;position:absolute;width:40px;height:25px;margin-left:-20px;border-radius:20px;border:2px solid #a9a9a9;background-color:#d3d3d3;-webkit-transition:color .1s,background-color .1s linear,border-color .1s linear;-ms-transition:color .1s,background-color .1s linear,border-color .1s linear;transition:color .1s,background-color .1s linear,border-color .1s linear}div.nil-sa-elements-toggle-style__selected{background:#3189d5}div.nil-sa-elements-toggle-style__selected .nil-sa-elements-toggle-style__slider{margin-left:17px}.nil-sa-elements-toggle-style__slider{margin-top:2px;margin-left:2px;width:17px;height:17px;border-radius:50%;background-color:#a9a9a9;cursor:pointer;-webkit-transition:margin-left .1s;-ms-transition:margin-left .1s;transition:margin-left .1s}", ""]);

// exports
exports.locals = {
	"text": "nil-sa-elements-toggle-style__text",
	"body": "nil-sa-elements-toggle-style__body",
	"selected": "nil-sa-elements-toggle-style__selected",
	"slider": "nil-sa-elements-toggle-style__slider"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-2!../node_modules/postcss-loader/lib??ref--2-3!../node_modules/less-loader/dist/cjs.js??ref--2-4!./components/elements/Toggle/style.less
// module id = 220
// module chunks = 0